import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, DatabaseView, Itinerary, Activity, TripSetup, ManageTrips, Wishlist, Inspiration } from './pages';
import Admin from './pages/Admin';
import SiteShell from './components/SiteShell';
import { GoogleMapsProvider } from './google/GoogleMapsProvider';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AuthScreen from './auth/AuthScreen';
import './App.css';

function AppShell() {
  const { user, loading, authMode } = useAuth();

  // Federated deployments (oidc/proxy) REQUIRE a login. Until the user is signed
  // in, render the sign-in screen instead of the data pages — otherwise the pages
  // mount, their API calls 401, and components crash doing `.map()` on the error
  // response. Local self-host (bootstrap fallback, enforcement off) is unaffected.
  if (loading) return null;
  if ((authMode === 'oidc' || authMode === 'proxy') && !user) {
    return <AuthScreen onClose={() => {}} />;
  }

  return (
    <Router>
      <SiteShell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trips" element={<ManageTrips />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/database" element={<DatabaseView />} />
          <Route path="/itinerary/:tripId/activity/:activityId" element={<Activity />} />
          <Route path="/itinerary/:tripId" element={<Itinerary />} />
          <Route path="/trip-setup/:tripId" element={<TripSetup />} />
          <Route path="/trips/:tripId/research" element={<Wishlist />} />
          <Route path="/trips/:tripId/wishlist" element={<Wishlist />} />
          <Route path="/trips/:tripId/inspiration" element={<Inspiration />} />
        </Routes>
      </SiteShell>
    </Router>
  );
}

function App() {
  return (
    <GoogleMapsProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </GoogleMapsProvider>
  );
}

export default App;
